import React from "react";
import InspectionDashboard from "./InspectionDashboard";

const FirmDashboard = () => (
  <div className="page-content dashboard-page-content piers-page">
    <InspectionDashboard />
  </div>
);

export default FirmDashboard;
